import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dots-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.count, (item) => {
      return (_openBlock(), _createBlock("div", {
        class: "dot-item",
        style: {'transitionDuration': (Math.random() + .3) + 's'},
        key: item
      }, [
        _createVNode("div", {
          class: "dot",
          style: {'animationDuration': (Math.random() + .5) + 's'}
        }, null, 4)
      ], 4))
    }), 128))
  ]))
}